import React, {FC} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import { SubmissionData } from './SubmissionData'

const SubmissionWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Submission Data</PageTitle>
      <SubmissionData />
    </>
  )
}

export default  SubmissionWrapper
